import { render, staticRenderFns } from "./SendChatPopup.vue?vue&type=template&id=ba444b48&scoped=true&"
import script from "./SendChatPopup.vue?vue&type=script&lang=ts&"
export * from "./SendChatPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendChatPopup.vue?vue&type=style&index=0&id=ba444b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba444b48",
  null
  
)

export default component.exports